export default __webpack_public_path__ + "static/media/WStoreCat_Merchandise.20390109.png";